"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.confirmEmailRegisterApiToken = void 0;
var Api_1 = require("@/api/remote/Api");
exports.confirmEmailRegisterApiToken = function (form, langCode, token) {
    Api_1.simulateFormPost("/" + langCode + "/account/confirmregisterbyemail", token, [
        ['Salutation', form.salutation],
        ['FirstName', form.firstname],
        ['LastName', form.lastname],
        ['PhoneNumberBody', form.phoneBody],
        ['CountryCode', form.phoneCode],
        ['PhoneNumber', form.phoneCode + "-" + form.phoneBody],
        ['Password', form.password],
        ['ConfirmPassword', form.passwordConfirm],
        ['SubscribeUpdates', form.subscribe],
        ['UserId', form.userId],
        ['Code', form.code],
    ]);
};
